module.exports = __webpack_public_path__ + "static/media/20ECE27.2479dba2.jpg";